export const app = {
  connectToYourWhatsappNumber: 'Se connecter à votre numéro WhatsApp',
  connectYourWhatsappBotWithYourWhatsappNumber: 'Connectez votre bot WhatsApp avec votre numéro WhatsApp',
  connect: 'Connecter',
};
